import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Search, HighlightOffOutlined, DescriptionOutlined } from "@material-ui/icons";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import WarningOutlinedIcon from "@material-ui/icons/WarningOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: "14px",
    fontFamily: "Poppins",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}))(Tooltip);

class TitleBar extends React.Component {
  constructor(props) {
    super(props);
    const nombreBusqueda = this.props.searchEmpty ? "" : localStorage.getItem("nombreBusqueda");
    this.state = {
      searchString:
        this.props.moduloArticulo === true && this.props.filtroArticulo !== undefined
          ? this.props.filtroArticulo
          : nombreBusqueda || "",
    };
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (props.filtroArticulo !== this.props.filtroArticulo) {
      this.setState({ searchString: props.filtroArticulo });
    }
    if (!this.props.searchEmpty) {
      const nombreBusqueda = localStorage.getItem("nombreBusqueda");
      if (nombreBusqueda) {
        this.setState({ searchString: nombreBusqueda });
      } else {
        this.setState({ searchString: "" });
      }
    }
  };

  handleOnSave = (event) => {
    if (this.props.handleOnSave) this.props.handleOnSave(event);
  };

  handleOnChange = (event) => {
    const { name, value } = event.target;
    let newValue = value;

    if (this.props.validator === "nombre") {
      newValue = newValue.replace(/[^a-zA-Z\s]/g, "");
    } else if (this.props.validator === "nombreynumeros") {
      newValue = newValue.replace(/[^a-zA-Z0-9\s]/g, "");
    }

    this.setState({
      [name]: newValue,
    });
  };

  handleOnCancel = (event) => {
    if (this.props.handleOnCancel) this.props.handleOnCancel(event);
  };

  handleEnableTrasladar = () => {
    if (this.props.handleEnableTrasladar) this.props.handleEnableTrasladar();
  };

  handleOnSearch = () => {
    if (this.props.handleOnSearch) {
      this.props.handleOnSearch(this.state.searchString);
    }
    if (!this.props.searchEmpty) {
      localStorage.setItem("nombreBusqueda", this.state.searchString);
    }
  };

  cleanSearch = () => {
    localStorage.setItem("nombreBusqueda", "");
    this.setState({ searchString: "" });
    setTimeout(() => {
      this.props.handleOnSearch("");
    }, 500);
  };

  renderButtons = () => {
    let buttons = null;

    if (this.props.type === "create") {
      buttons = (
        <div>
          <Link to={"/Catalogo/"} style={{ textDecoration: "none" }}>
            <Button variant="contained" className="btnSecundario" onClick={this.handleOnCancel}>
              CANCELAR
            </Button>
          </Link>

          <Button variant="contained" className="btnPrincipal" onClick={this.handleOnSave}>
            GUARDAR
          </Button>
        </div>
      );
    }

    if (this.props.type === "createArticulo") {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.props.handleOnCancel}>
            CANCELAR
          </Button>

          <Button variant="contained" className="btnPrincipal" onClick={this.handleOnSave}>
            GUARDAR
          </Button>
        </div>
      );
    }

    if (this.props.type === "edicionUsuario") {
      buttons = (
        <div>
          <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnCancel}>
            CANCELAR
          </Button>
        </div>
      );
    }

    if (this.props.type === "list") //Cuando listamos catalogos
    {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.handleOnSearch}>
            BUSCAR
          </Button>

          <Link to={"/Catalogo/catalogoNuevo"} style={{ textDecoration: "none" }}>
            <Button variant="contained" className="btnPrincipal">
              NUEVO
            </Button>
          </Link>
        </div>
      );
    }

    if (this.props.type === "edition") //Cuando editamos catalogos
    {
      buttons = (
        <div>
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={this.props.handleOnClickBorrar}
          >
            BORRAR
          </Button>
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={this.props.handleOnClickTrasladar}
            disabled={!this.props.trasladar}
          >
            TRASLADAR
          </Button>
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={this.props.handleOnClickOcultar}
            disabled={!this.props.ocultar}
          >
            OCULTAR
          </Button>
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={this.props.handleOnClickPublicar}
            disabled={!this.props.publicar}
          >
            PUBLICAR
          </Button>
          {/* <Link to={{pathname:'/Articulo/articuloNuevo' ,idCatalogo: this.props.catalogo.idCatalogo }} style={{ textDecoration: 'none' }} >} */}
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={this.props.handleOnClickArticulo}
          >
            ARTICULO
          </Button>
          {/*</Link> */}
        </div>
      );
    }
    if (this.props.type === "catalogEdit") //Cuando editamos entradas de catalogo
    {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.handleOnSearch}>
            BUSCAR
          </Button>
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={this.props.onAgregarEntrada}
          >
            + ARTICULOS
          </Button>
        </div>
      );
    }
    if (this.props.type === "catalogAddEntries") //Cuando insertamos nuevas entradas de catalogo
    {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.handleOnSearch}>
            BUSCAR1
          </Button>
          <Button variant="contained" className="btnSecundario" onClick={this.props.handleOnVolVer}>
            VOLVERr
          </Button>
        </div>
      );
    }
    if (this.props.type === "listUsuarios") //Cuando listamos usuarios
    {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.handleOnSearch}>
            BUSCAR
          </Button>
          <Button
            variant="contained"
            className="btnSecundario"
            onClick={this.props.handleOnAvanzado}
          >
            AVANZADA
          </Button>
          <Link to={"/Usuarios/Edit/0"} style={{ textDecoration: "none" }}>
            <Button variant="contained" className="btnPrincipal">
              NUEVO
            </Button>
          </Link>
        </div>
      );
    }

    if (this.props.type === "listRubros") //Cuando listamos rubros
    {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.handleOnSearch}>
            BUSCAR
          </Button>
          <Link to={"/Rubro/Edit/0"} style={{ textDecoration: "none" }}>
            <Button variant="contained" className="btnPrincipal">
              NUEVO
            </Button>
          </Link>
        </div>
      );
    }
    if (this.props.type === "listSubRubros") //Cuando listamos rubros
    {
      buttons = (
        <div>
          <Button variant="contained" className="btnSecundario" onClick={this.props.handleOnCancel}>
            Volver
          </Button>
          <Link to={"/SubRubro/Edit/0"} style={{ textDecoration: "none" }}>
            <Button variant="contained" className="btnPrincipal">
              NUEVO
            </Button>
          </Link>
        </div>
      );
    }
    return buttons;
  };

  handleCleanNivel = (u) => {
    this.props.handleIdNivel(u);
  };

  render() {
    const { niveles, selectedValue, onSelectChange } = this.props;
    return (
      <div className="titleBarContainer">
        <Row>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            className="pageTitleContainer"
            style={{
              marginTop:
                this.props.estadoPedido === "Borrador" ||
                this.props.estadoPedido === "Abandonado" ||
                this.props.estadoPedido === "Eliminado" ||
                this.props.estadoPedido === "Preparado"
                  ? "10px"
                  : "32px",
            }}
          >
            <div className="containerImgTitle">
              {this.props.showImage && <div className="imgTitle">{this.props.image}</div>}
              <div style={{ flexDirection: "row" }}>
                <CustomTooltip title={this.props.title} placement="top" arrow>
                  <div className="pageTitle">
                    {this.props.title} {/* Título con ellipsis */}
                  </div>
                </CustomTooltip>

                {this.props.titleDatos && (
                  <div className="pageTitleDatos">{this.props.titleDatos}</div>
                )}
              </div>
            </div>

            {this.props.showBtnInfo && (
              <div className="btnInfo">
                <InfoOutlinedIcon onClick={this.props.handleOnClickBtnInfo} />
              </div>
            )}

            {this.props.handleOnClickTurno !== undefined && (
              <div className="btnInfo">
                <DateRangeIcon onClick={this.props.handleOnClickTurno} />
              </div>
            )}

            {this.props.handleOnClickGeorreferenciar !== undefined && (
              <div className="facturacionIcon">
                <LocationOnIcon
                  style={{ color: this.props.colorIconLocation }}
                  onClick={this.props.handleOnClickGeorreferenciar}
                />
              </div>
            )}

            {this.props.handleOnClickBtnDetalleFraude && (
              <div className="facturacionIcon">
                <WarningOutlinedIcon
                  style={{ color: "ff0000" }}
                  onClick={this.props.handleOnClickBtnDetalleFraude}
                />
              </div>
            )}

            {this.props.handleOnClickDatosFacturacion !== undefined && (
              <div className="facturacionIcon">
                <DescriptionOutlined
                  style={{ color: "red" }}
                  onClick={this.props.handleOnClickDatosFacturacion}
                />
              </div>
            )}
          </Col>

          <Col xs={12} md={8} lg={8} xl={8} className="colContainer">
            <div className="actionsContainer">
              {/* NIVELES */}
              {this.props.habilitarNivel && this.props.viewNiveles && (
                <div className="selectNiveles">
                  {/* COMBO RUBRO */}
                  <TextField
                    id="textFieldRubro"
                    className="filterInput"
                    style={{ textAlign: "left" }}
                    fullWidth
                    select
                    error={false}
                    label="Nivel"
                    value={selectedValue}
                    name="idNivel"
                    onChange={(e) => onSelectChange(parseInt(e.target.value, 10))}
                  >
                    {niveles !== undefined && niveles.length > 0
                      ? niveles.map((e) => {
                          return (
                            <MenuItem key={e.id} value={e.id}>
                              {e.descripcion}
                            </MenuItem>
                          );
                        })
                      : ""}
                  </TextField>
                </div>
              )}

              {/* DEFAULT SEARCH BAR */}
              {this.props.showSearch && this.props.searchBar === undefined && (
                <div className="searchBar">
                  <Input
                    value={this.state.searchString}
                    name="searchString"
                    placeholder={this.props.searchPlaceholder}
                    inputProps={{ "aria-label": "Description" }}
                    endAdornment={
                      <InputAdornment position="end">
                        {this.state.searchString.length > 0 ? (
                          <HighlightOffOutlined
                            onClick={this.cleanSearch}
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          <Search />
                        )}
                      </InputAdornment>
                    }
                    onChange={this.handleOnChange}
                  />
                </div>
              )}

              {/* CUSTOM SEARCH BAR */}
              {this.props.searchBar !== undefined && (
                <div style={{ display: "flex", margin: "10px 10px" }}>{this.props.searchBar}</div>
              )}

              <div className="actionButtons">
                {this.props.buttons === undefined ? (
                  /* DEFAULT BUTTONS */
                  <div>
                    {this.props.handleOnSearch !== undefined && (
                      <Button
                        variant="contained"
                        className="btnSecundario masFiltros"
                        onClick={this.handleOnSearch}
                      >
                        BUSCAR
                      </Button>
                    )}

                    {this.props.handleOnBack !== undefined && (
                      <Button
                        variant="contained"
                        className="btnSecundario"
                        onClick={this.props.handleOnBack}
                      >
                        Volver
                      </Button>
                    )}

                    {this.props.handleOnBack2 !== undefined && (
                      <Button
                        variant="contained"
                        className="btnPrincipal2"
                        onClick={this.props.handleOnBack2}
                      >
                        Volver
                      </Button>
                    )}

                    {this.props.handleOnBack3 !== undefined && (
                      <Button
                        variant="contained"
                        className="btnPrincipal3"
                        onClick={this.props.handleOnBack3}
                      >
                        Volver
                      </Button>
                    )}

                    {this.props.handleOnSearchAdvanced !== undefined && (
                      <Button
                        variant="contained"
                        className="btnSecundario masFiltros"
                        onClick={this.props.handleOnSearchAdvanced}
                      >
                        {this.props.title === "Usuarios" && this.props.cantFiltros !== 0 && (
                          <div className="counter">{this.props.cantFiltros}</div>
                        )}
                        + FILTROS
                      </Button>
                    )}

                    {this.props.newButtonLink !== undefined && ( //NEW BUTTON TO MAKE A LINK
                      <Link to={this.props.newButtonLink}>
                        <Button variant="contained" className="btnPrincipal">
                          NUEVO
                        </Button>
                      </Link>
                    )}

                    {this.props.handleOnNewButton !== undefined && ( //NEW BUTTON WITH DIFFERENT BEHAVIOUR
                      <Button
                        variant="contained"
                        className="btnPrincipal"
                        onClick={this.props.handleOnNewButton}
                      >
                        NUEVO
                      </Button>
                    )}

                    {this.props.handleOnAddArticuloButton !== undefined && ( //NEW BUTTON WITH DIFFERENT BEHAVIOUR
                      <Button
                        variant="contained"
                        className="btnPrincipal"
                        onClick={this.props.handleOnAddArticuloButton}
                      >
                        + ARTICULOS
                      </Button>
                    )}

                    {this.props.cancelarButtonLink !== undefined && (
                      <Link to={this.props.cancelarButtonLink} style={{ textDecoration: "none" }}>
                        <Button
                          variant="contained"
                          className="btnSecundario"
                          onClick={this.handleOnCancel}
                        >
                          CANCELAR
                        </Button>
                      </Link>
                    )}

                    {this.props.handleOnSave !== undefined && (
                      <Button
                        variant="contained"
                        className="btnPrincipal"
                        onClick={this.props.handleOnSave}
                      >
                        GUARDAR
                      </Button>
                    )}
                  </div>
                ) : (
                  // CUSTOM BUTTONS
                  <div>{this.props.buttons}</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

TitleBar.propTypes = {
  title: PropTypes.string.isRequired,
  titleDatos: PropTypes.string,
  type: PropTypes.string,
  showImage: PropTypes.bool,
  image: PropTypes.node,

  /* search bar props */
  showSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  searchBar: PropTypes.node,
  searchEmpty: PropTypes.bool,

  /* button props */
  buttons: PropTypes.node,
  handleOnBack: PropTypes.func,
  handleOnSearch: PropTypes.func,
  handleOnSearchAdvanced: PropTypes.func,

  /* icon props */
  colorIconLocation: PropTypes.string,

  handleOnNewButton: PropTypes.func,
  newButtonLink: PropTypes.string,
  cancelarButtonLink: PropTypes.string,
  handleOnCancel: PropTypes.func,
  handleOnSave: PropTypes.func,
  showBtnInfo: PropTypes.bool,
  handleOnClickBtnInfo: PropTypes.func,
  handleOnClickGeorreferenciar: PropTypes.func,
  handleOnClickDatosFacturacion: PropTypes.func,
  handleOnClickBtnDetalleFraude: PropTypes.func,

  /* ARTICULOS */
  filtroArticulo: PropTypes.string,
  moduloArticulo: PropTypes.bool,
  niveles: PropTypes.array,
  nivelSeleccionado: PropTypes.number,
};

TitleBar.defaultProps = {
  showSearch: false,
  searchEmpty: false,
  searchPlaceholder: "",
  showBtnAvanzada: false,
  moduloArticulo: false,
  type: "",
  titleDatos: "",
};

export default TitleBar;
